import { forwardRef, type Ref, type SVGProps } from "react";

function SvgScallopedUserBadgeWithStarColored(
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) {
  return (
    <svg ref={ref} viewBox="0 0 114 107" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M54.6046 13.4026C60.0042 8.00301 68.7585 8.00311 74.1583 13.4026L75.3282 14.5725C78.5831 17.8272 82.9977 19.6555 87.6006 19.6555H87.8985C95.5349 19.6555 101.726 25.8463 101.726 33.4827V33.7805C101.726 38.3837 103.555 42.798 106.81 46.053L107.979 47.2229C113.378 52.6226 113.378 61.3769 107.979 66.7766L106.81 67.9465C103.555 71.2014 101.726 75.6159 101.726 80.219V80.5168C101.726 88.1532 95.5349 94.344 87.8985 94.344H87.6006C82.9975 94.344 78.5831 96.1731 75.3282 99.428L74.1583 100.597C68.7585 105.997 60.0043 105.997 54.6046 100.597L53.4346 99.428C50.1797 96.1731 45.7653 94.344 41.1622 94.344H40.8643C33.2279 94.344 27.0372 88.1533 27.0372 80.5168V80.219C27.0371 75.616 25.2089 71.2014 21.9542 67.9465L20.7842 66.7766C15.3848 61.3769 15.3847 52.6226 20.7842 47.2229L21.9532 46.053H21.9542C25.2088 42.7981 27.0372 38.3835 27.0372 33.7805V33.4827C27.0372 25.8463 33.2279 19.6555 40.8643 19.6555H41.1622C45.7651 19.6555 50.1797 17.8272 53.4346 14.5725L54.6046 13.4026Z"
        fill="url(#scalloped_user_badge_with_star_svg__a)"
        stroke="#D7D4FF"
        strokeWidth="3.52941"
      />
      <path
        d="M62.0831 39.75C63.1417 39.75 64.0001 40.6084 64.0001 41.667C63.9999 42.7254 63.1416 43.583 62.0831 43.583H52.5001C51.4416 43.583 50.5831 44.4415 50.5831 45.5V68.5C50.5831 69.5585 51.4416 70.417 52.5001 70.417H54.6085C55.4965 66.0427 59.3638 62.75 64.0001 62.75C68.6365 62.75 72.5038 66.0427 73.3917 70.417H75.5001C76.5587 70.417 77.4171 69.5585 77.4171 68.5V58.917C77.4171 57.8586 78.2747 57.0002 79.3331 57C80.3917 57 81.2501 57.8584 81.2501 58.917V68.5C81.2501 71.6756 78.6758 74.25 75.5001 74.25H52.5001C49.3245 74.25 46.7501 71.6756 46.7501 68.5V45.5C46.7501 42.3244 49.3245 39.75 52.5001 39.75H62.0831Z"
        fill="url(#scalloped_user_badge_with_star_svg__b)"
      />
      <path
        d="M64.0001 48.375C67.1758 48.375 69.7501 50.9494 69.7501 54.125C69.75 57.3005 67.1757 59.875 64.0001 59.875C60.8246 59.875 58.2503 57.3005 58.2501 54.125C58.2501 50.9494 60.8245 48.375 64.0001 48.375Z"
        fill="url(#scalloped_user_badge_with_star_svg__c)"
      />
      <path
        d="M77.4171 37.5C80.5928 37.5 83.1671 40.0744 83.1671 43.25C83.167 46.4255 80.5927 49 77.4171 49C74.2416 49 71.6673 46.4255 71.6671 43.25C71.6671 40.0744 74.2415 37.5 77.4171 37.5Z"
        fill="url(#scalloped_user_badge_with_star_svg__d)"
      />
      <path
        d="M16.03 1.58812C16.03 1.00335 15.556 0.529297 14.9712 0.529297C14.3865 0.529297 13.9124 1.00335 13.9124 1.58812C13.9124 5.99318 12.9402 8.92324 11.0938 10.7696C9.24752 12.6159 6.31746 13.5881 1.9124 13.5881C1.32763 13.5881 0.853577 14.0622 0.853577 14.6469C0.853577 15.2317 1.32763 15.7058 1.9124 15.7058C6.31746 15.7058 9.24752 16.678 11.0938 18.5243C12.9402 20.3706 13.9124 23.3007 13.9124 27.7058C13.9124 28.2905 14.3865 28.7646 14.9712 28.7646C15.556 28.7646 16.03 28.2905 16.03 27.7058C16.03 23.3007 17.0023 20.3706 18.8486 18.5243C20.6949 16.678 23.625 15.7058 28.03 15.7058C28.6148 15.7058 29.0889 15.2317 29.0889 14.6469C29.0889 14.0622 28.6148 13.5881 28.03 13.5881C23.625 13.5881 20.6949 12.6159 18.8486 10.7696C17.0023 8.92324 16.03 5.99318 16.03 1.58812Z"
        fill="#372FAA"
      />
      <defs>
        <linearGradient
          id="scalloped_user_badge_with_star_svg__a"
          x1="64.3816"
          y1="7.58813"
          x2="64.3816"
          y2="106.412"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#DBD8FE" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
        <linearGradient
          id="scalloped_user_badge_with_star_svg__b"
          x1="65.8751"
          y1="36"
          x2="65.8751"
          y2="74.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#372FAA" />
          <stop offset="1" stopColor="#5146E6" />
        </linearGradient>
        <linearGradient
          id="scalloped_user_badge_with_star_svg__c"
          x1="65.8751"
          y1="36"
          x2="65.8751"
          y2="74.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#372FAA" />
          <stop offset="1" stopColor="#5146E6" />
        </linearGradient>
        <linearGradient
          id="scalloped_user_badge_with_star_svg__d"
          x1="65.8751"
          y1="36"
          x2="65.8751"
          y2="74.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#372FAA" />
          <stop offset="1" stopColor="#5146E6" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgScallopedUserBadgeWithStarColored);
export default ForwardRef;
